import React from 'react'
import {DocumentChange} from "firebase/firestore"
import update from "immutability-helper"


export const dispatchChange = <T>(dispatch: React.Dispatch<React.SetStateAction<T[]>>, change: DocumentChange<T>) => {
    dispatch(prev => {
        if (change.type === 'added') {
            return update(prev, {
                $push: [change.doc.data()]
            })

        } else {
            let index = prev.findIndex((t: any) => t.key === change.doc.id)
            if (index >= 0) {
                if (change.type === "modified") {
                    return update(prev, {
                        [index]: {
                            $set: change.doc.data()
                        }
                    })

                } else if (change.type === "removed") {
                    return update(prev, {
                        $splice: [[index, 1]]
                    })
                }
            }
            return prev
        }
    })
}


export const hideLoading = (): void => {
    let loadingElm = document.getElementById('loading')
    if (loadingElm) {
        loadingElm.classList.add('hide')
    }
}

export const showLoading = (): void => {
    let loadingElm = document.getElementById('loading')
    if (loadingElm) {
        loadingElm.classList.remove('hide')
    }
}

export const setLoadingText = (text: string): void => {
    const loadingMessageElm = document.getElementById('loading-message')
    if (loadingMessageElm !== null) {
        loadingMessageElm.classList.remove('blink')
        loadingMessageElm.textContent = text
    }
}
